<!-- src/App.vue -->
<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive include="TallyHome">
      <component :is="Component" :key="route.matched[0]?.path || route.name" />
    </keep-alive>
  </router-view>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { AppBootstrap } from '@/mechanism/appBootstrap';

onMounted(async () => {
  await AppBootstrap.init();
});

onUnmounted(async () => {
  await AppBootstrap.destroy();
});
</script>

<style>
/* 1. 基础重置 */
:root {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
}

/* 2. 允许输入框操作 */
input, textarea {
  -webkit-user-select: auto;
  user-select: auto;
}

/* 3. 全局核心修复：
   禁止 html 和 body 出现任何形式的横向滚动
   这是解决左滑失效的关键！
*/
html, body {
  margin: 0;
  padding: 0;
  width: 100%; /* 绝对不要用 100vw，容易溢出 */
  height: 100%;
  background-color: #f7f8fa;

  /* 仅禁用垂直橡皮筋，保留水平手势通道 */
  overscroll-behavior-y: none;
  /* 禁用系统字体大小调整带来的影响 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  touch-action: auto;
}

#app {
  width: 100%;
  height: 100%;
  position: relative; /* 确保子元素定位基准正确 */
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Vant 图标点击穿透修复 */
.van-icon.clickable {
  pointer-events: auto !important;
}
</style>